// Shared category options and auto-code generation for Medidas + Proforma

export const CATEGORIA_OPTIONS = [
  { value: 'gypsum', label: 'Gypsum' },
  { value: 'pintura', label: 'Pintura' },
  { value: 'empaste', label: 'Empaste' },
  { value: 'impermeabilizacion', label: 'Impermeabilización' },
  { value: 'general', label: 'General' },
];

export const CATEGORY_LABELS: Record<string, string> = {
  gypsum: 'Gypsum',
  pintura: 'Pintura',
  empaste: 'Empaste',
  impermeabilizacion: 'Impermeabilización',
  general: 'General',
};

const CATEGORY_PREFIX: Record<string, string> = {
  gypsum: 'GYP',
  pintura: 'PIN',
  empaste: 'EMP',
  impermeabilizacion: 'IMP',
  general: 'GEN',
};

// Common Spanish stop words to exclude from code generation
const STOP_WORDS = new Set([
  'DE', 'DEL', 'LA', 'LAS', 'EL', 'LOS', 'EN', 'CON', 'Y', 'A',
  'AL', 'UN', 'UNA', 'POR', 'PARA', 'SE', 'SU', 'O', 'E',
]);

/** Deterministic 3-digit hash (000–999) derived from the input string. */
function hashThreeDigits(str: string): string {
  let h = 0;
  for (let i = 0; i < str.length; i++) {
    h = (h * 31 + str.charCodeAt(i)) & 0xffff;
  }
  return String(h % 1000).padStart(3, '0');
}

/**
 * Generate an alphanumeric code from category + description.
 * Format: PREFIX-WORD1-WORD2-NNN
 *   - Stop words and prefix-echo words are skipped
 *   - NNN is a deterministic 3-digit hash of the original description
 * Example: impermeabilizacion + "IMPERMEABILIZACIÓN DE FILOS CON CHOVA"
 *          → "IMP-FIL-CHO-247"
 */
export function generateItemCode(categoria: string, descripcion: string): string {
  const prefix = CATEGORY_PREFIX[categoria] ?? 'OTR';

  if (!descripcion.trim()) return `${prefix}-`;

  const cleanDesc = descripcion
    .toUpperCase()
    .replace(/[^A-Z0-9\sÑ]/g, '')
    .trim();

  const words = cleanDesc
    .split(/\s+/)
    .filter(Boolean)
    .filter((w) => w.slice(0, 3) !== prefix)  // skip prefix echo
    .filter((w) => !STOP_WORDS.has(w))         // skip stop words
    .slice(0, 2);

  const num = hashThreeDigits(cleanDesc);

  if (words.length === 0) return `${prefix}-${num}`;

  const suffix = words.map((w) => w.slice(0, 3)).join('-');
  return `${prefix}-${suffix}-${num}`;
}
